import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsSupportWebsitePagesRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsSupportWebsitePagesRoute.tsx';
import { AsyncSupportWebsiteNav } from '@jira/navigation-apps__horizontal-nav-csm-support-website/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import {
	HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
	HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation,
} from './ui/support-website-pages/index.tsx';

export const helpCenterSettingsSupportWebsitePagesRouteEntry: Route = createEntry(
	helpCenterSettingsSupportWebsitePagesRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.support-website.pages',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			horizontal: fg('csm_contact_us_rte') ? undefined : AsyncSupportWebsiteNav,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () =>
			fg('csm_contact_us_rte')
				? HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation
				: HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
		resources: [...getServiceDeskNavigationResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
